// extracted by mini-css-extract-plugin
export default {"listWithIconsItem":"HPgiBpTeoQLodXXTJuiy","listWithIconsItemWrapper":"e9n6zBn7FZEXWSu4FO1O","listWithIconsItemContent":"zkEXC4EZ3_Qo0Yh9HdMF"};